import React, { Component } from 'react'
import { createBrowserHistory } from 'history'
import querystring from 'query-string'
import axios from 'axios'
import { withGetScreen } from 'react-getscreen'

import Cookie from './utils/Cookie'
import Login from './components/Login/Login.jsx'
import MatrikkelSearch from './components/MatrikkelSearch/MatrikkelSearch.jsx'
import MatrikkelMap from './components/MatrikkelMap/MatrikkelMap.jsx'
import MatrikkelSearchEvents from './components/MatrikkelSearch/MatrikkelSearchEvents.js'

import Header from './components/Header/Header';

class App extends Component {
    history = createBrowserHistory()

    state = {
        domainKlasse: null,
        matrikkelBubbleId: null,
        tokenInfo: null,
        settings: null,
        isMapActive: false,
        isSearchTinglystDokumentEnabled: false,
        isUtskriftBestillingEnabled: false
    }

    UNSAFE_componentWillMount = () => {
        this.hasResults = false;
        
        this.history.listen((location, action) => {
            if (action != 'POP') return
            this.updateSelectedMatrikkelObject(location);
        })

        this.updateSelectedMatrikkelObject(location);
    }

    componentDidUpdate = (prevProps) => {
        if (!this.matrikkelMap) return;
        this.setMapDevice()
    }

    updateSelectedMatrikkelObject(location) {
        const parsed = querystring.parse(location.search.toLowerCase());

        if (parsed.adresseid) {
            this.setState({ domainKlasse: "Adresse", matrikkelBubbleId: parsed.adresseid })
            return
        }

        if (parsed.byggid) {
            this.setState({ domainKlasse: "Bygg", matrikkelBubbleId: parsed.byggid })
            return
        }

        if (parsed.eierid) {
            this.setState({ domainKlasse: "Eier", matrikkelBubbleId: parsed.eierid })
            return
        }

        if (parsed.matrikkelenhetid)
            this.handleMatrikkelenhetSelected(parsed.matrikkelenhetid)

        if (parsed.kommunenr && parsed.gardsnr && parsed.bruksnr) {
            this.setState({
                kommunenummer: parsed.kommunenr,
                gardsnummer: parsed.gardsnr,
                bruksnummer: parsed.bruksnr,
                festenummer: parsed.festenr || 0,
                seksjonsnummer: parsed.seksjonsnr || 0
                })
        }

        if (parsed.kommunenr && parsed.adressenavn) {
            this.setState({
                kommunenummer: parsed.kommunenr,
                adressenavn: parsed.adressenavn,
                nummer: parsed.nummer || 0,
                bokstav: parsed.bokstav,
                })
        }
    }

    handleMatrikkelSearchEvent = (event) => {
        if (!this.matrikkelMap.state.mapLoaded) {
            setTimeout(() => {
                this.handleMatrikkelSearchEvent(event)
            }, 100);
            return
        }

        if (event.type == MatrikkelSearchEvents.ResultChanged) {
            this.hasResults = event.data.hasResults
            this.setMapDevice()
            
            // Clear the map if no result
            if (this.matrikkelMap && !this.hasResults) {
                this.matrikkelMap.clearHighlight();
            }
        }

        if (event.type == MatrikkelSearchEvents.ShowObject) {
            this.showObjectInMap(event)
            this.handleMobileMapView();            
        }

        if (event.type == MatrikkelSearchEvents.ZoomToObject) {
            this.showObjectInMap(event)
        }

        if (event.type == MatrikkelSearchEvents.SelectAdresse) {
            this.history.push(`?adresseid=${event.data.adresse.adresseId}`)
            this.state.domainKlasse = "Adresse"
            this.state.matrikkelBubbleId = event.data.adresse.adresseId
        }

        if (event.type == MatrikkelSearchEvents.SelectBygg) {
            this.history.push(`?byggid=${event.data.bygg.byggId}`)
            this.state.domainKlasse = "Bygg"
            this.state.matrikkelBubbleId = event.data.bygg.byggId
        }

        if (event.type == MatrikkelSearchEvents.SelectEier) {
            this.history.push(`?eierid=${event.data.eier.eierId}`)
            this.state.domainKlasse = "Eier"
            this.state.matrikkelBubbleId = event.data.eier.eierId
        }

        if (event.type == MatrikkelSearchEvents.SelectMatrikkelenhet) {
            this.history.push(`?matrikkelenhetid=${event.data.matrikkelenhet.matrikkelenhetId}`)
            this.state.domainKlasse = "Matrikkelenhet"
            this.state.matrikkelBubbleId = event.data.matrikkelenhet.matrikkelenhetId
        }

        if (event.type == MatrikkelSearchEvents.ShowSearchTinglystDokument) {
            if (!this.state.isSearchTinglystDokumentEnabled) this.setState({isSearchTinglystDokumentEnabled:true, isUtskriftBestillingEnabled:false})
        }

        if (event.type == MatrikkelSearchEvents.HideSearchTinglystDokument) {
            if (this.state.isSearchTinglystDokumentEnabled) this.setState({isSearchTinglystDokumentEnabled:false})
        }

        if (event.type == MatrikkelSearchEvents.ShowUtskriftBestilling) {
            if (!this.state.isUtskriftBestillingEnabled) this.setState({isUtskriftBestillingEnabled:true, isSearchTinglystDokumentEnabled:false})
        }

        if (event.type == MatrikkelSearchEvents.HideUtskriftBestilling) {
            if (this.state.isUtskriftBestillingEnabled) this.setState({isUtskriftBestillingEnabled:false})
        }

        if (event.type == MatrikkelSearchEvents.ResetMatrikkelSearch) {
            this.history.push('');
            this.setState({isSearchTinglystDokumentEnabled:false, isUtskriftBestillingEnabled:false, domainKlasse:null, matrikkelBubbleId:null})
        }
    }

    showObjectInMap = event => {
        if (event.data.type == MatrikkelSearchEvents.ShowAdresse) {
            this.matrikkelMap.showAdresse(event.data.adresse.adresseId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowAnleggsprojeksjonsflate) {
            this.matrikkelMap.showAnleggsprojeksjonsflate(event.data.anleggsprojeksjonsflate.anleggsprojeksjonsflateId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowBruksenhet) {
            this.matrikkelMap.showAdresse(event.data.bruksenhet.adresseId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowBygg) {
            this.matrikkelMap.showBygg(event.data.bygg.byggId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowFestegrunn) {
            this.matrikkelMap.showMatrikkelenhet(event.data.festegrunn.matrikkelenhetId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowFestegrunn) {
            this.matrikkelMap.showMatrikkelenhet(event.data.festegrunn.matrikkelenhetId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowMatrikkelenhet) {
            this.matrikkelMap.showMatrikkelenhet(event.data.matrikkelenhet.matrikkelenhetId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowSeksjon) {
            this.matrikkelMap.showMatrikkelenhet(event.data.seksjon.matrikkelenhetId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowTeig) {
            this.matrikkelMap.showTeig(event.data.teig.teigId)
        }

        if (event.data.type == MatrikkelSearchEvents.ShowStedsnavn) {
            this.matrikkelMap.showStedsnavn(event.data.stedsnavn)
        }
    }

    handleMatrikkelenhetSelected = matrikkelenhetId => {
        this.setState({ domainKlasse: "Matrikkelenhet", matrikkelBubbleId: matrikkelenhetId, isMapActive: false, isSearchTinglystDokumentEnabled: false, isUtskriftBestillingEnabled:false })
    }

    handleSelectionInMap = data => {
        this.setState({ domainKlasse: data.domain, matrikkelBubbleId: data.id, isMapActive: false, isSearchTinglystDokumentEnabled: false, isUtskriftBestillingEnabled:false })
    }

    handleTokenChanged = (tokenInfo, settings) => {
        var newState = {
            tokenInfo: tokenInfo
        }

        if (settings) newState.settings = settings

        if (!this.state.kommunenummer || !settings) {
            this.setState(newState)
            return
        }

        if (this.state.kommunenummer && this.state.adressenavn) {
            axios.get(`${settings.baseUrl}api/adresse/adresseid`, {
                params: {
                    token: tokenInfo.token,
                    kommunenummer: this.state.kommunenummer,
                    adressenavn: this.state.adressenavn,
                    nummer: this.state.nummer,
                    bokstav: this.state.bokstav,
                }
            }).then(({ data }) => {
                newState.kommunenummer = null
                newState.adressenavn = null
                newState.nummer = null
                newState.bokstav = null
    
                if (!data.adresseId) {
                    this.setState(newState)
                } else {
                    newState.domainKlasse = "Adresse"
                    newState.isMapActive = false
                    newState.matrikkelBubbleId = data.adresseId
                    this.setState(newState)
                }
            });
            return
        }

        axios.get(`${settings.baseUrl}api/matrikkelenhet/matrikkelenhetid`, {
            params: {
                token: tokenInfo.token,
                kommunenummer: this.state.kommunenummer,
                gardsnummer: this.state.gardsnummer,
                bruksnummer: this.state.bruksnummer,
                festenummer: this.state.festenummer,
                seksjonsnummer: this.state.seksjonsnummer
            }
        }).then(({ data }) => {
            newState.kommunenummer = null
            newState.gardsnummer = null
            newState.bruksnummer = null
            newState.festenummer = null
            newState.seksjonsnummer = null

            if (!data.matrikkelenhetId) {
                this.setState(newState)
            } else {
                newState.domainKlasse = "Matrikkelenhet"
                newState.isMapActive = false
                newState.matrikkelBubbleId = data.matrikkelenhetId
                this.setState(newState)
            }
        });
    }

    handleLogout = () => {
        Cookie.removeAuthenticationCookie()
        this.setState({ tokenInfo: null, settings: null })
    }

    handleCloseDocumentViewer = () => {
        this.setState({gammelGrunnbok: null})
    }

    handleMobileMapView = () => {
        if (!this.state.isMapActive && this.props.isMobile()) 
            this.setState({isMapActive: true})
    }

    showMatrikkelSearch = (event) => {
        event.stopPropagation()
        this.setState({isMapActive: false})
    }

    setMapDevice = () => {
        const device = this.props.isMobile() ? "mobile": (this.props.isTablet() ? "tablet" : "desktop");
        this.matrikkelMap.setMapDevice(device, this.state.isMapActive, this.hasResults);
    }

    render() {
        if (this.state.tokenInfo == null)
            return (
                <React.Fragment>
                    <Header />
                    <Login onTokenChanged={this.handleTokenChanged} />
                </React.Fragment>
            )

        const mobileMap = this.state.isMapActive && this.props.isMobile();   
        
        return (
            <React.Fragment>
                <Header onLogout={this.handleLogout} settings={this.state.settings} token={this.state.tokenInfo.token} isMobile={this.props.isMobile()} onEvent={this.handleMatrikkelSearchEvent} />
                {mobileMap ? (
                    <div className="hamburger esri-widget--button" onClick={this.showMatrikkelSearch}>
                        <span aria-hidden="true" role="presentation" className="esri-icon esri-icon-drag-horizontal"></span>
                    </div>
                ) : (
                    <MatrikkelSearch domainKlasse={this.state.domainKlasse} matrikkelBubbleId={this.state.matrikkelBubbleId} token={this.state.tokenInfo.token} settings={this.state.settings} onEvent={this.handleMatrikkelSearchEvent} isSearchTinglystDokumentEnabled={this.state.isSearchTinglystDokumentEnabled} isUtskriftBestillingEnabled={this.state.isUtskriftBestillingEnabled} />
                )}
                <MatrikkelMap ref={map => this.matrikkelMap = map} tokenInfo={this.state.tokenInfo} settings={this.state.settings} isMobile={this.props.isMobile()} onMatrikkelenhetSelected={this.handleMatrikkelenhetSelected} onSelectionInMap={this.handleSelectionInMap} />
            </React.Fragment>
        );
    }
}

export default withGetScreen(App, { mobileLimit: 640, tabletLimit: 1024, shouldListenOnResize: true })